import styled from 'styled-components'

export const Nested = styled.div`
  margin-left: 20px;
  font-size: 11px;
`
